import { baseThunkConfig, createAppSlice } from '@exp/redux/createAppSlice';

import { getOrg, getSimilarBrands } from '../api/organization';

/**
 * Org Slice
 */
const orgSlice = createAppSlice({
  initialState: {},
  name: 'org',
  reducers: (create) => ({
    fetchOrg: create.asyncThunk(async (orgId) => {
      const { organizations } = await getOrg(orgId);
      const [org] = organizations || [];
      return org;
    }, baseThunkConfig),

    fetchSimilarBrands: create.asyncThunk((orgId) => getSimilarBrands(orgId), baseThunkConfig),
  }),
});

export const { fetchOrg, fetchSimilarBrands } = orgSlice.actions;

export default orgSlice;
